import {createContext, useContext, useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useLocalStorage} from '../../utilities/hooks/useLocalStorage';
import Cookies from 'universal-cookie';

type TAuthProviderProps = {
  children: React.ReactNode;
};

export const AuthContext = createContext<IAuthContext>({
  user: null,
  login: () => null,
  logout: () => null,
  update: () => null,
  authLoading: true,
  profile: undefined,
  supplierProfile: undefined,
  isSupplier: false,
});

export const AuthProvider = ({children}: TAuthProviderProps) => {
  const [user, setUser] = useLocalStorage('user', null);
  const [authLoading, setAuthLoading] = useState(true);
  const navigate = useNavigate();

  const login = async (data: IUser, route = '/home') => {
    setUser(data);
    navigate(route);
    setAuthLoading(false);
  };

  const update = async (profile: IProfile) => {
    setAuthLoading(false);
    setUser({
      ...user,
      profile,
    });
  };

  const logout = () => {
    setUser(null);

    document.cookie.split(';').forEach(c => {
      const name = c.replace(/^ +/, '').split('=')[0];
      // Clear on the exact host
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      // Clear on the parent domain (when we logged in with mazraeapp)
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mazraeapp.com;`;
    });
    const cookies = new Cookies();
    cookies.update();

    window.localStorage.clear();
    window.sessionStorage.clear();
    // window.location.href = '/';
    navigate('/steps');
  };

  const value = useMemo(() => {
    return {
      user,
      login,
      logout,
      update,
      authLoading,
      profile: (user as IUser)?.profile?.supplier_profile
        ? (user as IUser)?.profile?.supplier_profile
        : (user as IUser)?.profile?.farmer_profile,
      supplierProfile: (user as IUser)?.profile?.supplier_profile
        ? (user as IUser)?.profile?.supplier_profile
        : undefined,
      isSupplier:
        (user as IUser)?.profile &&
        (user as IUser)?.profile?.supplier_profile &&
        Object.keys(user?.profile?.supplier_profile).length !== 0
          ? true
          : false,
    };
  }, [user]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
